export default {
  buildCreate(name, agents) {
    let agentsList = [];
    agents.forEach(agent => {
      agentsList.push({'type': 'agents', 'id': agent});
    });
    return {
      'data': {
        'attributes': {
          'name': name,
        },
        'relationships': {
          'agents': {'data': agentsList},
        },
        'type': 'groups',
      },
    };
  },
  buildUpdate(name, id, agents) {
    let agentsList = [];
    agents.forEach(agent => {
      agentsList.push({'type': 'agents', 'id': agent});
    });
    return {
      'data': {
        'attributes': {
          'name': name,
        },
        'relationships': {
          'agents': {'data': agentsList},
        },
        'id': id,
        'type': 'groups',
      },
    };
  },
  async getExistingGroups(axios, groupStore, token) {
    let response = await axios.get('/api/business/groups/', {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
    response.data.data.forEach(group => {
      groupStore.replaceOrAdd(group);
    });
  },
  async createGroup(data, axios, token) {
    return await axios.post('/api/business/groups/', data, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  },
  async deleteGroup(groupId, axios, token) {
    return await axios.delete(`/api/business/groups/${groupId}/`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  },
  async updateGroup(groupId, data, axios, token) {
    return await axios.patch(`/api/business/groups/${groupId}/`, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  }
};
